module.exports = __webpack_public_path__ + "img/bf.009fb12d.svg";